import { render, staticRenderFns } from "./HistoryEmptyDefaultLayout.vue?vue&type=template&id=4be6fddf&scoped=true"
import script from "./HistoryEmptyDefaultLayout.vue?vue&type=script&lang=js"
export * from "./HistoryEmptyDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be6fddf",
  null
  
)

export default component.exports